import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgCartAlt = function SvgCartAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M0 2.5a1.25 1.25 0 011.25-1.25h2.309c.884 0 1.63.656 1.741 1.533l.281 2.248a.25.25 0 00.248.219h15.419a2.749 2.749 0 012.623 3.575l-2.061 5.493a2.735 2.735 0 01-2.625 1.932H6.858a2.238 2.238 0 01-2.224-1.908l-.716-3.656a1.25 1.25 0 112.471-.38l.651 3.232a.249.249 0 00.247.212h11.898a.25.25 0 00.241-.181l2.061-5.5a.25.25 0 00-.239-.323H5.384A2.255 2.255 0 013.15 5.778l-.226-1.809a.25.25 0 00-.248-.219H1.25A1.25 1.25 0 010 2.5zM17.248 22.75a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM7.5 22.75a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5z"
  }));
};

export default SvgCartAlt;